const JobBox = {
  props: {
    job: {
      default: {},
    },
    bookmarked: Boolean,
  },
  components: {
    Bookmark,
  },
  methods: {
    openJob($event, job) {
      if ($event.target.tagName === 'BUTTON') {
        return;
      }
      window.open(`/empleo/oferta/${job.slug}`);
    },
  },
  template: `
    <div
      class="job"
      @click="openJob($event, job)"
      :class="{ ['-'+job.status]: true }"
    >
      <div class="uk-grid">
        <div class="uk-width-expand">
          <strong>{{ job.title }}</strong><br>
          {{ job.activity.name }} en {{ job.location.title }}<br>
          <p class="uk-margin-remove">
            Publicada <span :title="job.createdAt | dateFormat">{{ job.createdAt | relativeTime }}</span>
          </p>
          <Bookmark :jid="job._id" :bookmarked="bookmarked" />
        </div>
        <div class="uk-visible@m">
          <a class="uk-button uk-button-default">
            Ver oferta
          </a>
        </div>
      </div>
    </div>
	`,
};
